// localstorge name
export const TOKEN_NAME = 'access-token';

export const WAREHOUSE_TOKEN_PAYLOAD_NAME = 'wt-operation-token-payload';

export const REFRESH_TOKEN_NAME = 'refresh-token';

export const TOKEN_PAYLOAD_NAME = 'token-payload';

export const CURRENT_USER = 'current-user';

export const LOCALE = 'umi_locale';

export const FILE_SIZE_LIMIT = 10 * 1024 * 1024; // 10M

export const LOCALES = ['en-US', 'zh-TW'];

// Scopes (Permissions)
export const OMS_PERMISSION_ADMIN = 'ml_oms_admin';
// export const OMS_PERMISSION_MANAGE_INBOUND = 'ml_oms_manage_inbound';
export const OMS_PERMISSION_MANAGE_ORDER = 'ml_oms_manage_order';
export const OMS_PERMISSION_MANAGE_INVENTORY = 'ml_oms_manage_inventory';

// export const OMS_PERMISSION_VIEW_INBOUND = 'ml_oms_view_inbound';
export const OMS_PERMISSION_VIEW_ORDER = 'ml_oms_view_order';
export const OMS_PERMISSION_VIEW_INVENTORY = 'ml_oms_view_inventory';
export const OMS_PERMISSION_VIEW_REPORT = 'ml_oms_view_report';


export const COLORS = {
  success: '#52c41a',
  primary: '#1677FF',
  error: '#f5222d',
  warning: '#faad14',
  orange: '#fa8c16',
  blue: '#20a8d8',
  preview: '#3e515b',
  green: '#239B56',
  pending: '#32CD32',
  approved: '#B67E06',
  rejected: '#aa0099',
  submitted: '#14B639',
  pinky: '#ffa3b5',
};

export const USER_TYPE_COLORS = {
  U: '#f5222d', //user
  C: '#52c41a', //contact
};

export const NORMAL_STATUS_COLORS = {
  0: '#f5222d', //error
  1: '#52c41a', //success
};

export const SUPPLIER_STATUS_COLORS = {
  0: '#f5222d', //error
  1: COLORS.success, //success
  10: COLORS.primary, //pending
  11: COLORS.rejected, //rejected
};

// Status Color
export const STATUS_COLORS = {
  1: '#20a8d8', // "Work In Progress"
  2: '#ffc107', // "Revision In Progress"
  3: '#32CD32', // "Ready for decision"
  4: '#aa0099', // "Rejected"
  5: '#1677FF', // "Awaiting Approval"
  10: '#B67E06', // "Approved"
  15: '#14B639', // "Submitted"
  20: '#f86c6b', // "Supplier Rejected"
  25: '#32CD32', // "Ready For Delivery"
  27: '#20a8d8', // "Delivery In Progress"
  29: '#32CD32', // "Delivered"
  30: '#ffc107', // "Revision In Progress With DO"
  31: '#f86c6b', // "Approval In Progress With DO"
  32: '#1677FF', // "Not Approved With DO"
  33: '#B67E06', // "Approved With DO"
  35: '#ffc107', // "Revision In Progress WithGR"
  36: '#f86c6b', // "Approval In Progress With GR"
  37: '#1677FF', // "Not Approved With GR"
  38: '#B67E06', // "Approved With GR"
  40: '#108ee9', // "DN Created"
  50: '#1890FF', // "Converted"
  60: '#63c2de', // "Fully Delivered"
  70: '#63c2de', // "Completed"
  80: '#63c2de', // "Reconciled"
  81: '#B67E06', // "Being Reconciled"
  82: '#1890FF', // "Partially Reconciled"
  90: '#63c2de', // "Require Investigation"
  91: '#63c2de', // "Awaiting Settlement"
  92: '#63c2de', // "Settled"
  98: '#63c2de', // "Closed"
  99: '#f86c6b', // "Canceled"
};

export const STATUS_ORDER_COLORS = {
  0: '#f86c6b', // "error"
  1: '#2db7f5', // "Work In Progress"
  2: '#0256B4', // "wms pre order"
  3: '#32CD32', // "processing"
  4: '#aa0099', // "wms in progress"
  5: '#1677FF', // "Awaiting Approval"
  6: '#14B639', // "shipped"
  7: '#FB8760',
  8: '#32CD32', // "Approved"
  9: '#1677FF', // "warning"
  10: '#B67E06', // "Approved"
};

export const STATUS_DELIVERY_ORDER_COLORS = {
  1: '#2db7f5', // "Work In Progress"
  2: '#0256B4', // "wms pre order"
  3: '#1677FF', // "processing"
  4: '#aa0099', // "wms in progress"
  5: '#464D04', // "Awaiting Approval"
  6: '#14B639', // "shipped"
  7: '#FB8760',
  8: '#aa0099',
  9: '#00A399',
  10: '#14B639',
  11: '#f86c6b',
};

export const STATUS_SHIPMENT_COLORS = {
  0: '#1677FF', // "NO SYNC TO shipment"
  10: '#20a8d8', // "Work In Progress"
  11: '#f86c6b', // "custom tracking route"
  12: '#32CD32', // "custom tracking route"
  13: '#f86c6b', // "custom tracking route"
  14: '#1677FF', // "custom tracking route"
  15: '#2db7f5', // "custom tracking route"
  16: '#2db7f5', // "custom tracking route"
  17: '#2db7f5', // "custom tracking route"
  18: '#fa8c16', // "custom tracking route"
  19: '#B67E06', // "custom tracking route"
  20: '#B67E06', //IN_TRANSIT
  30: '#32CD32', //OUT_FOR_DELIVERY
  40: '#f86c6b', //FAILED_ATTEMPT
  50: '#14B639', //DELIVERED
  60: '#B67E06', //AVAILABLE_FOR_PICKUP
  70: '#f86c6b', //EXCEPTION
  71: '#1890FF', //RETURN_SENDER
  72: '#B67E06', //LOST
  80: '#f86c6b', //EXPIRED
  90: '#B67E06', //PENDING
  '-1': '#f86c6b', //CANCELED
};

export const STATUS_ASN_COLORS = {
  0: '#32CD32', // "processing"
  1: '#2db7f5', // "CONFIRM"
  2: '#2db7f5', // "PARTIALLY_CONFIRM"
};

export const WMS_INBOUND_ORDER_STATUS_COLORS = {
  1: '#1677FF',
  3: '#20a8d8',
  4: '#faad14',
  5: '#FF6A29',
  7: '#795548',
  9: '#464d04',
  10: '#14B639',
  11: '#1677FF',
  21: '#B67E06',
  22: '#f4680b',
  23: '#aa0099',
  24: '#a64917',
  25: '#52c41a',
  26: '#1890FF',
  29: '#63c2de',
  99: '#f5222d',
};

export const OMS_PLATFORM_INVENTORY_STATUS_COLORS = {
  1: '#1677FF',
  3: '#B67E06',
  6: '#00A399',
  99: '#f5222d',
};

export const WMS_DELIVERY_NOTE_STATUS_COLORS = {
  1: '#1677FF',
  3: '#00068D',
  5: '#E06837',
  6: '#6C009E',
  7: '#FB8760',
  9: '#20a8d8',
  10: '#00A399',
  20: '#14B639',
  51: '#B67E06',
  52: '#1890FF',
  53: '#aa0099',
  54: '#a64917',
  55: '#eba44c',
  59: '#a64917',
  63: '#f59e0b',
  88: '#63c2de',
  99: '#f5222d',
};

export const OMS_MARKETPLACE_ORDER_STATUS_COLORS = {
  1: '#1677FF',
  3: '#20a8d8',
  4: '#faad14',
  5: '#FF6A29',
  6: '#00a399',
  7: '#795548',
  9: '#464d04',
  10: '#00A399',
  11: '#14B639',
  21: '#B67E06',
  22: '#f4680b',
  23: '#aa0099',
  24: '#a64917',
  25: '#52c41a',
  26: '#1890FF',
  29: '#63c2de',
  99: '#f5222d',
};

export const OMS_FULFILLMENT_ORDER_STATUS_COLORS = {
  1: '#20a8d8',
  2: '#03776c',
  3: '#592b03',
  4: '#a64917',
  5: '#1677FF',
  9: '#aa0099',
  10: '#00A399',
  19: '#aa0099',
  20: '#14B639',
  21: '#B67E06',
  22: '#f4680b',
  88: '#63c2de',
  99: '#f5222d',
};

export interface ISelectDefaultOption {
  optionValue: number;
  optionText: string;
}

export const OMS_DELIVERY_EXPORT = 1;
export const OMS_DELIVERY_IMPORT = 2;

export const JOR_WMS_UNKNOWN_SKU = 'unknown_sku';


// export const MarketplaceOrderStatusRequestCancel = 88;
// export const MarketplaceOrderStatusCancelled = 99;
// export const MarketplaceOrderStatusPacked = 7;

export const MarketplaceOrderStatusShippedStock = 6;
export const MarketplaceOrderStatusDelivered = 10;
export const MarketplaceOrderStatusCompleted = 20;

export const WMS_OUTBOUND_PICK_TYPE_NORMAL = 1;
export const WMS_OUTBOUND_PICK_TYPE_AMR = 3;
export const WMS_OUTBOUND_PICK_TYPE_AMR_AND_NORMAL = 6;

export const WMS_RENT_CBM_UNIT_TOTAL_CBM = 1;
export const WMS_RENT_CBM_UNIT_PER_ASN = 3;

export const DELIVERY_DISPATCH_ERROR_CODE_WRONG_STATUS_CANCEL = '8001';
export const DELIVERY_DISPATCH_ERROR_CODE_WRONG_STATUS_SHIPPED = '8002';
export const DELIVERY_DISPATCH_ERROR_CODE_WRONG_STATUS_OTHERS = '8003';

export const USER_TYPE_INTERNAL_USER = 'internal_user';
export const USER_TYPE_SMS_CLIENT_USER = 'sms_client_user';
export const USER_TYPE_FMS_CLIENT_USER = 'fms_client_user';
export const USER_TYPE_WMS_OPERATION_USER = 'wms_operation_user';


export const RequireStarStyle = {
  color: '#ff4d4f',
  marginRight: '4px',
  fontFamily: 'SimSun, sans-serif',
  fontSize: '14px',
};


export const NoShelfLifeValue = 999;

/**
 * This is URL query param, e.g. http://localhost:8080/fms/outbound?xxx=lmedodo .
 * For allow internal user ignore the "Document Limit" at export function in INBOUND/OUTBOUND/RMA document pages.
 * As we usually logined via client's account, we cant control the limit by permission, account, etc.
 * If set xxx=lmedodo, it will ignore limit logic in backend
 */

